import { Box, Checkbox, FormControlLabel, Stepper, Step } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useCallback, useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadAction } from "redux/reducers/top";
import { useForm } from "react-hook-form";
import AlertComplete from "components/ui/alert-complete";
import AlertTimer from "components/ui/alert-timer";
import DrawerComplete from "components/ui/drawer-complete";
import { useHistory } from "react-router-dom";
import axios from "axios";
import { Cookies } from "react-cookie";
import { getCryptoPwd, onlyNumber } from "assets/js/common";

const useStyles = makeStyles((theme) => ({}));
const cookies = new Cookies();

export default function Password(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const [open, setOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [activeStep2, setActiveStep2] = useState(0);
  const [step, setStep] = useState(1);

  const {
    register,
    getValues,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      pwd: "",
      pwdChk: "",
    },
  });

  const handleAlertTimerClose = () => {
    setOpenAlert(false);
  };

  const handleAlertClose = () => {
    setOpen(false);
  };

  const savePassword = () => {
    const hashedPw = getCryptoPwd(getValues("pwd"));
    axios
      .post("/api/mb/member/modify-pwd", {
        no: cookies.get("no"),
        pwd: hashedPw,
      })
      .then((res) => {
        if (res.data.data) {
          setOpen(true);
        }
      });
  };

  useEffect(() => {
    setValue("pwd", onlyNumber(getValues("pwd")));
    setActiveStep(getValues("pwd").length);

    if (getValues("pwd").length == 6) {
      setStep(2);
    }
  }, [watch("pwd")]);

  useEffect(() => {
    setValue("pwdChk", onlyNumber(getValues("pwdChk")));
    setActiveStep2(getValues("pwdChk").length);

    if (getValues("pwdChk").length == 6) {
      if (getValues("pwd") == getValues("pwdChk")) {
        savePassword();
      } else {
        let el = document.getElementById("ghostInput2");
        if (el) el.blur();
        setTimeout(() => {
          setOpenAlert(true);
          setValue("pwdChk", "");
        }, 100);
      }
    }
  }, [watch("pwdChk")]);

  useEffect(() => {
    dispatch(
      loadAction({ back: true, title: "간편 비밀번호 찾기", menu: false })
    );
  }, []);

  return (
    <main id="main" className="container nopad">
      <div className="layout-flex">
        <div className="layout-body login-body">
          {step == 1 ? (
            <>
              <p className="text-top">새 비밀번호 6자리를 입력해 주세요</p>
              <div className="stepper-cont">
                <div className="stepper-pw">
                  <Stepper activeStep={activeStep} alternativeLabel>
                    {Array.from(Array(6)).map((_, index) => (
                      <Step key={index} />
                    ))}
                  </Stepper>
                  <input
                    autoFocus
                    type="tel"
                    id="ghostInput"
                    {...register("pwd")}
                    autoComplete="off"
                    className="ghost-input"
                    maxLength="6"
                  />
                </div>
              </div>
            </>
          ) : (
            <>
              <p className="text-top">한번 더 입력해 주세요</p>
              <div className="stepper-cont">
                <div className="stepper-pw">
                  <Stepper activeStep={activeStep2} alternativeLabel>
                    {Array.from(Array(6)).map((_, index) => (
                      <Step key={index} />
                    ))}
                  </Stepper>
                  <input
                    type="tel"
                    id="ghostInput2"
                    {...register("pwdChk")}
                    autoComplete="off"
                    className="ghost-input"
                    maxLength="6"
                  />
                </div>
              </div>
            </>
          )}
          <p className="info-txt">
            간편 비밀번호는 로그인을 위해 꼭 필요한 정보입니다.
            <br />
            잊어버리지 않도록 주의하세요.
          </p>
          <AlertTimer
            open={openAlert}
            handleAlertTimerClose={handleAlertTimerClose}
            text={"일치하지 않습니다."}
          />
        </div>
      </div>
      <DrawerComplete
        open={open}
        handleDrawerClose={() => {
          handleAlertClose();
          history.replace("/");
        }}
        text={"간편 비밀번호가 변경되었습니다."}
        callback={() => {}}
      />
    </main>
  );
}
